<div>
  <button
    mat-button
    class="border-icon-button"
    color="primary"
    (click)="emitClick()"
    [ngClass]="{ 'v2-button': v2, 'v2-delete-button': v2Delete, 'white-background': whiteBackground, 'borderless': borderless  }"
    [disabled]="isDisabled()"
  >
    <mat-icon>{{ icon }}</mat-icon>
    <span>
      <ng-content></ng-content>
    </span>
  </button>
</div>
